module.exports = __webpack_public_path__ + "static/media/grid.6f152448.svg";